/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */
export const BEFORE_ITEMS_TYPE = 'BEFORE_ITEMS_TYPE';
export const SWITCH_ITEMS_TYPE = 'SWITCH_ITEMS_TYPE';
export const AFTER_ITEMS_TYPE = 'AFTER_ITEMS_TYPE';
export const BREADCRUMBS_TYPE = 'BREADCRUMBS_TYPE';
export const MAINTENANCE_TYPE = 'MAINTENANCE_TYPE';
export const URL_ONLY_MAIN_ITEMS_RENDER = 'URL_ONLY_MAIN_ITEMS_RENDER';
